import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Stn_View = () => {
   useAuthRedirect();
  const [data, setData] = useState([]);
  const branch = localStorage.getItem("branch");
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  const canView  = hasPermission("STN Requisition Approval", "view");
  const canEntry = hasPermission("STN Requisition Approval", "entry");
            
  useEffect(() => {
    fetchData();
  }, [ branch]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/stnApproval_list", {
        params: { branch: branch }
      });
      setData(response.data.dataList);
      setFilteredData(response.data.dataList);
    } catch (error) {
      console.error("Error fetching dataList:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (stn_id) => {
    if (!stn_id) return;
  
    // Show confirmation popup
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to approve this bill?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve!",
      cancelButtonText: "Cancel",
    });
  
    if (result.isConfirmed) {
      try {
                Swal.fire({
                    title: "Submitting...",
                    text: "Please wait while we process your request.",
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
        const response = await axios.post("https://rfs2.infraconsoft.net.in/api/stn_approve", {stn_id});
        
        if (response.data.success) {
          // Show success alert
          Swal.fire({
            title: "Approved!",
            text: "STN Approved Successfully!",
            icon: "success",
          });
          fetchData();
        } else {
          Swal.fire({
            title: "Failed!",
            text: "Failed to Approve .",
            icon: "error",
          });
        }
        navigate(`/inventory/stn_approvalview`)
      } catch (error) {
        console.error("Error approving STN:", error);
        Swal.fire({
          title: "Error!",
          text: "Error processing approval.",
          icon: "error",
        });
      }
    }
  };

  const handleDisapprove = async (stn_id) => {
  
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to disapprove this Request?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Disapprove!",
      cancelButtonText: "Cancel",
    });
  
    if (result.isConfirmed) {
      try {
        Swal.fire({
                    title: "Submitting...",
                    text: "Please wait while we process your request.",
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
        const response = await axios.post("https://rfs2.infraconsoft.net.in/api/stn_disapprove", {
            stn_id
        });
  
     if (response.data.success) {
  Swal.fire("Disapproved!", "Request Disapproved!", "success");
  await fetchData(); 
} else {
  Swal.fire("Failed!", "Failed to Disapprove Bill.", "error");
}

      } catch (error) {
        console.error("Error disapproving bill:", error);
        Swal.fire("Error!", "Error processing disapproval.", "error");
      }
    }
  };



  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.stn_purnumber || "").toLowerCase().includes(term) ||
       String(item.stn_dpt || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };
  


  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);


 if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">STN Requisition Approval</h2>
          <Time />
        </section>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by STN No"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Requisition No</th>
                <th>From Branch</th>
                <th>To Branch</th>
                <th>Date</th>
                <th>Department</th>
                <th>H.O.D</th>
                <th>Indent Ref.</th>
                <th>Head Meterial</th>
                {canEntry && (
                  <>
                <th>Approval</th>
                <th>DisApproval</th>
                </>
                )}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>
                      <Link to={`/inventory/viewstn_newapproval/${item.stn_purnumber}`}>
                        {item.stn_purnumber}
                      </Link>
                    </td>
                    <td>{item.stn_branchcode}</td>
                    <td>{item.stn_branch}</td>
                    <td>{new Date(item.stn_now).toLocaleDateString()}</td>
                    <td>{item.stn_dpt}</td>
                    <td>{item.stn_hod}</td>
                    <td>{item.stn_inref}</td>
                    <td>{item.stn_headmet}</td>
                    {canEntry && (
                      <>
                    <td> <button class="approve-btn" onClick={() => handleApprove(item.stn_purnumber)}>✅ Approve</button></td>
                    <td><button class="disapprove-btn" onClick={() => handleDisapprove(item.stn_purnumber)} >❌ Disapprove</button></td>
                    </>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Stn_View;
